import React, { useState, useMemo, useRef } from 'react';
import { Modal, Fade } from '@material-ui/core';
import cn from 'classnames';
import styles from "./OverlayContext.module.scss";
const getTransitionDuration = isTestMode => isTestMode ? 0 : 225;
const DefaultModalWrapper = _ref => {
  let {
    children
  } = _ref;
  return /*#__PURE__*/React.createElement(React.Fragment, null, children);
};
const makeModalCustomBackdrop = isTestMode => {
  return _ref2 => {
    let {
      open,
      onClick,
      modal
    } = _ref2;
    const FadeComp = Fade;
    return /*#__PURE__*/React.createElement(FadeComp, {
      timeout: getTransitionDuration(isTestMode),
      in: open,
      onClick: onClick
    }, /*#__PURE__*/React.createElement("div", {
      className: cn(styles.modalBackdrop, {
        [styles.modalBg]: !modal.transparentBackdrop
      })
    }));
  };
};
export function ModalContainer(_ref3) {
  let {
    modal,
    ModalWrapper = DefaultModalWrapper,
    isTestMode,
    disableEnforceFocus,
    triggerClose,
    onModalExited
  } = _ref3;
  const [returnValue, setReturnValue] = useState(undefined);
  const canDismissModal = useRef();
  const registerCanDismiss = cb => canDismissModal.current = cb;
  const BackdropComponent = useMemo(() => makeModalCustomBackdrop(isTestMode), [isTestMode]);
  const dismissModal = async function dismissModal(value) {
    let {
      force
    } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (canDismissModal.current && !force) {
      const confirmed = await canDismissModal.current();
      if (!confirmed) return;
    }
    setReturnValue(value);
    triggerClose(modal.id);
  };
  modal.dismissModal = dismissModal;
  const modalProps = {
    dismissModal,
    registerCanDismiss
  };
  return /*#__PURE__*/React.createElement(Modal, {
    open: modal.isOpen,
    disableEnforceFocus: disableEnforceFocus || modal.disableEnforceFocus,
    closeAfterTransition: true,
    BackdropComponent: BackdropComponent,
    BackdropProps: {
      modal
    },
    onClose: (e, reason) => {
      if (reason === 'escapeKeyDown' && modal.closeOnEscapeKey) {
        dismissModal();
      }
    }
  }, /*#__PURE__*/React.createElement(Fade, {
    timeout: getTransitionDuration(isTestMode),
    in: modal.isOpen,
    onExited: () => {
      modal.resolve(returnValue);
      onModalExited(modal.id);
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.modalContainer,
    style: modal.theme,
    "data-testid": "modal-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.modalBackdrop,
    "data-testid": "modal-backdrop",
    onClick: () => {
      if (modal.closeOnClickOutside) {
        dismissModal();
      }
    }
  }), /*#__PURE__*/React.createElement(ModalWrapper, modalProps, modal.content && (typeof modal.content === 'function' ? modal.content(modalProps) : /*#__PURE__*/React.cloneElement(modal.content, modalProps))))));
}